// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles-module--hero--2HNlv","item":"styles-module--item--3YuC9","label":"styles-module--label--34bhT"};